import React from "react";
import classnames from 'classnames';

import "./styles.scss"

type Props = {
    activeTab: "plan" | "sales";
    labels: Record<string, string>;
    onChange: (tab: "plan" | "sales") => void;
    className?: string
};

export const PPDWidgetLeagueRatingTabs = ({ activeTab, labels, onChange, className }: Props) => {
    return (
        <nav className={classnames("ppd-widget-league-rating-tabs", className)}>
            {(["plan", "sales"] as const).map((tab) => (
                <button
                    key={tab}
                    className={classnames("ppd-widget-league-rating-tabs__item", {
                        "ppd-widget-league-rating-tabs__item--active": activeTab === tab,
                    })}
                    onClick={() => onChange(tab)}
                >
                    {labels[tab]}
                </button>
            ))}
        </nav>
    );
};
